import { useRef, useState } from 'react';
import { Tooltip } from 'antd';

/**
 * Nhãn menu, hiện tooltip khi chữ bị cắt cụt (TCR-1215).
 *
 * KHÔNG dùng `Typography.Text` với `ellipsis.tooltip` được: chính antd đặt
 * `display: inline` cho `.ant-typography-ellipsis-single-line` nằm trong nhãn
 * menu (menu/style/index.js, theo issue antd #41143). Phần tử `inline` có
 * `clientWidth` bằng 0 nên Typography không bao giờ nhận ra là chữ bị cắt —
 * tooltip không bao giờ hiện, trong khi chữ vẫn cụt vì menu tự cắt bằng CSS
 * của nó (`overflow: hidden` + `text-overflow: ellipsis` trên chính mục menu).
 *
 * Nên tự đo. Và đo ở ĐÚNG phần tử đang cắt chữ — antd cắt ở mục menu với hàng
 * thường, ở `.ant-menu-title-content` với tiêu đề nhóm — nên dò ngược lên vài
 * lớp thay vì đoán trước là lớp nào.
 */

/** Số lớp cha dò ngược lên: đủ tới mục menu, không đi lạc ra ngoài. */
const MAX_DEPTH = 4;

function isClipped(node: HTMLElement | null): boolean {
  let current: HTMLElement | null = node;
  for (let depth = 0; current && depth < MAX_DEPTH; depth += 1) {
    // +1 để bỏ qua sai số làm tròn khi trình duyệt thu phóng.
    if (current.scrollWidth > current.clientWidth + 1) return true;
    current = current.parentElement;
  }
  return false;
}

export function MenuLabel({ text }: { text: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  /*
   * Tự điều khiển `open` thay vì để Tooltip tự quyết: nếu chỉ đổi `title` lúc
   * rê chuột thì Tooltip đã quyết xong từ trước khi đo, nên lần rê đầu tiên
   * không hiện gì. Đo và mở trong cùng một lần dựng lại thì lần đầu đã đúng.
   */
  const [open, setOpen] = useState(false);

  return (
    <Tooltip title={text} open={open} placement="right">
      <span
        ref={ref}
        onMouseEnter={() => setOpen(isClipped(ref.current))}
        onMouseLeave={() => setOpen(false)}
      >
        {text}
      </span>
    </Tooltip>
  );
}

export { isClipped };
